import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from "react-bootstrap";
import { appConfig } from "../../config";
import CreditNotesimage from "./CreditNotesimage";
import ModalImage from "react-modal-image";
import PDFViewer from "pdf-viewer-reactjs";
var dateFormat = require("dateformat");

class CreditNotesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditnoteImgModal: false,
    };
  }

  mouseOver = (data) => {
    // console.log(data);
    this.setState({ creditnoteImgModal: true, ImageData: data });
  };

  closeImgModel = () => {
    this.setState({ creditnoteImgModal: false });
  };

  getExtension = (filename) => {
    return filename.split(".").pop();
  };

  viewPDF = (pdfUrl) => {
    //alert(pdfUrl);
  };

  render() {
    // console.log(this.props.orderToShow);

    const data =
      this.props.CreditNotesToShow && this.props.CreditNotesToShow.item
        ? this.props.CreditNotesToShow && this.props.CreditNotesToShow.item
        : null;

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            backdrop="static"
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white",
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Credit Note Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="profilebasicdetailscont">
                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Credit Number{" "}
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.crdtRefNo}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">Credit From</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null &&
                          data.returnId !== null &&
                          data.returnId.orderToName}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">Credit To</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null &&
                          data.returnId !== null &&
                          data.returnId.orderFromName}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">Chemist GST</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.crdtToGST}
                      </p>
                    </div>
                  </Col>
                </Row> */}

                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Quantity </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.qnty}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Description{" "}
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.descp}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Preview</p>
                      <p className="profilebasicdetailscontper">
                        {data&&data.imgUrl?
                          (this.getExtension(data.imgUrl)==="pdf"?
                            (<div>
                              <Image className="ctgryImg"
                                style={{cursor:"pointer"}}
                                src={[
                                  data && data.imgUrl !== undefined
                                    ? require("../../assets/img/default_pdf_icon.png")
                                    : "No Preview"
                                ]}
                                onClick={() =>
                                  data.imgUrl !== undefined
                                  ? this.mouseOver({data: data.imgUrl}): null
                                }
                              />
                            <CreditNotesimage
                              show={this.state.creditnoteImgModal}
                              handleClose={this.closeImgModel}
                              ImageData={this.state.ImageData}
                            /></div>)
                            :
                            (<ModalImage 
                              small={data&&data.imgUrl&&(appConfig.imgServerip+`/getCrdtImg?imgName=${data.imgUrl}`)}
                              large={data&&data.imgUrl&&(appConfig.imgServerip+`/getCrdtImg?imgName=${data.imgUrl}`)}
                              hideDownload={true} hideZoom={true} className="ctgryImg"
                            />)
                          ):null
                        }
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Amount</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.amnt?"INR "+data.amnt:null}
                      </p>
                    </div>
                  </Col>
                </Row> */}

                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Created Date & Time
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.createdAt
                          ? dateFormat(data.createdAt, "dd-mmm-yyyy, h:MM TT")
                          : null}
                      </p>
                    </div>
                  </Col>
                </Row> */}

                <Row>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Reference Number
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.crdtRefNo}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Distributor
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null &&
                            data.returnId !== null &&
                            data.returnId.orderToName}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">Chemist</p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null &&
                            data.returnId !== null &&
                            data.returnId.orderFromName}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Chemist GST
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.crdtToGST}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Description
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p
                          style={{
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                            textTransform: "capitalize",
                          }}
                        >
                          {data !== null && data.descp ? (
                            data.descp
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              No description provided
                            </span>
                          )}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">Amount</p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.amnt
                            ? "INR " + data.amnt
                            : null}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Created Date & Time
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, "dd/mm/yyyy, h:MM TT")}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">Preview</p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <div>
                          {data && data.imgUrl ? (
                            this.getExtension(data.imgUrl) === "pdf" ? (
                              <div>
                                <Image
                                  className="ctgryImg"
                                  style={{ cursor: "pointer" }}
                                  src={[
                                    data && data.imgUrl !== undefined
                                      ? require("../../assets/img/default_pdf_icon.png")
                                      : "No Preview",
                                  ]}
                                  onClick={() =>
                                    data.imgUrl !== undefined
                                      ? this.mouseOver({ data: data.imgUrl })
                                      : null
                                  }
                                />
                                <CreditNotesimage
                                  show={this.state.creditnoteImgModal}
                                  handleClose={this.closeImgModel}
                                  ImageData={this.state.ImageData}
                                />
                              </div>
                            ) : (
                              <ModalImage
                                small={
                                  data?.imgUrl &&
                                  `${appConfig.ip}/attachments/preview/${encodeURIComponent(data.imgUrl)}`
                                }
                                large={
                                  data?.imgUrl &&
                                  `${appConfig.ip}/attachments/preview/${encodeURIComponent(data.imgUrl)}`
                                }
                                hideDownload={true}
                                hideZoom={true}
                                className="ctgryImg"
                              />
                            )
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default CreditNotesView;
